
import { defineComponent, ref, computed } from 'vue'
import { useAgreementModule } from '@/modules/agreements'
import { useRoute, useRouter } from 'vue-router'
import AgreementSingleMember from '@/components/agreements/agreement-member.vue'
import { AgreementMember } from '@/modules/agreements/types'
import { AgreementsRouteNames } from '@/router/routes-names'
import AgreementNewMember from '@/components/agreements/adding-agreement-member/new-member.vue'

export default defineComponent({
    name: 'view-agreements-agreement-members',
    components: { AgreementSingleMember, AgreementNewMember },
    async setup () {
        const route = useRoute()
        const router = useRouter()
        const { getAgreement, getAgreementMembers, agreementMembers } = useAgreementModule()

        const agreement = await getAgreement(route.params.agreementId as string)
        await getAgreementMembers(agreement.agreementId)

        const expiredMembers = agreementMembers.value.filter((member: AgreementMember) => !member.isActive && !agreement.draft).length

        function onGoToList () {
            router.push({ name: AgreementsRouteNames.LIST, query: { page: route.query.page } })
        }

        function onGoToInfo () {
            router.push({
                name: AgreementsRouteNames.SHOW,
                params: { agreementId: route.params.agreementId },
                query: { ...route.query }
            })
        }

        const showActiveMembers = ref<boolean | string>(true)
        const currentlyAssigned = computed(() => agreementMembers.value.filter((member: AgreementMember) => (member.isActive || agreement.draft)))

        const filteredAgreementMembers = computed(() => {
            if (showActiveMembers.value === 'all') {
                return agreementMembers.value
            }
            return agreementMembers.value.filter((member: AgreementMember) => (member.isActive === showActiveMembers.value || agreement.draft))
        })

        return {
            agreement,
            agreementMembers,
            expiredMembers,
            onGoToList,
            onGoToInfo,
            filteredAgreementMembers,
            showActiveMembers,
            AgreementsRouteNames,
            currentlyAssigned
        }
    }
})
